<template>
    <div v-if="xinhua && placeholder" class="placeholder" :class="{show: show}" :style="`background-color: ${bgcolor}`"></div>
    <nav v-if="xinhua && show" :style="`background-color: ${bgcolor}`">
        <div class="content" :style="`background-color: ${bgcolor}`">
            <van-icon
                size="24"
                :color="color"
                v-if="showBack"
                name="arrow-left"
                @click="back"
            /><span v-else class="icon"></span>
            <span class="title-box" :style="{color: color}">
                <slot name="title"></slot>
            </span>
            <van-icon v-if="ellipsis" size="22" :color="color" name="ellipsis" @click="arouseShare"/>
        </div>
    </nav>
</template>

<script>
import client from '@/configs/client.js'

export default {
    data() {
        return {
            title: "",
            right: "",
            fixed: false,
            xinhua: client.xinhua,
            showBack: this.hasLIcon
        };
    },
    props: {
        bgcolor: {
            type: String,
            default() {
                return 'white'
            }
        },
        color: {
            type: String,
            default() {
                return 'white';
            }
        },
        ellipsis: {
            type: Boolean,
            default() {
                return true;
            }
        },
        hasLIcon: {
            type: Boolean,
            default() {
                return true;
            }
        },
        show: {
            type: Boolean,
            default() {
                return true;
            }
        },
        placeholder: {
            type: Boolean,
            default() {
                return true;
            }
        },
        close: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    methods: {
        back() {
            if (client.xinhua) { // 客户端内
              if (String(this.$route.query.close) === '1') { // 携带了返回参数，直接返回
                this.$router.back()
              } else if (history.length > 1) { // 没有携带参数，可能是router-link打开，则判断历史记录
                  if (this.$route.path === '/') { // 根目录直接关闭
                      if (client.ios) {
                          window.webkit.messageHandlers.closePage.postMessage(null);
                      } else if (client.android) {
                          window.xinhuanet.closePage();
                      }
                  } else {
                      this.$router.back()
                  }
              } else {
                if (client.ios) {
                  window.webkit.messageHandlers.closePage.postMessage(null);
                } else if (client.android) {
                  window.xinhuanet.closePage();
                }
              }
            } else {
              this.$router.back()
            }
        }
    },
};
</script>

<style scoped lang="scss">
.placeholder {
    height: 32px;
    &.show {
        height: 80px;
    }
}
nav {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
    padding-top: 38px;
    .content {
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .icon {
        display: inline-block;
        width: 30px;
    }
}
.title-box {
    position: absolute;
    left: 50%;
    font-size: 18px;
    transform: translateX(-50%);
}
</style>
